import React, {useEffect, useState} from "react";
import useStandService from "../../api/services/useStandService";
import {default as MediaElement} from "../Media/Media";
import BookableStatus from "../BookableStatus/BookableStatus";
import Loading from "../Loading/Loading";
import Button from "../Button/Button";
import {Link} from "react-router-dom";
import bookingIcon from "../../assets/icons/booking-white.svg";
import boostIcon from "../../assets/icons/profile-boost-white.svg";
import cogIcon from "../../assets/icons/cog.svg";
import cartIcon from "../../assets/icons/cart.svg";
import mapIcon from "../../assets/icons/map.svg";


const StandTileList = () => {

  const {userShowCollection} = useStandService()
  const [stands, setStands] = useState([])
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    userShowCollection(
      (data) => {
        setStands(data || [])
        setIsLoading(false)
      },
      () => setIsLoading(false),
    )
  }, [])

  if (isLoading) return <Loading/>

  if (stands.length === 0) {
    return <p className="empty-state">Je hebt nog geen stands aangemaakt.</p>
  }

  return (
    <div className="component-stand-tile-list">
      {stands.map((stand) => (
        <div key={stand.id} className="stand-tile">
          <Link to={stand.slug ? '/stand/' + stand.slug : '/user/stand/' + stand.id + '/edit'} className="tile-main">
            <div className="tile-image">
              {stand.overview_media
                ? <MediaElement media={stand.overview_media} size="tile"/>
                : <div className="no-image">🚚</div>
              }
            </div>
            <div className="tile-info">
              <h3>{stand.label}</h3>
              <BookableStatus bookable={stand}/>
              {stand.slogan && <p className="tile-slogan">{stand.slogan}</p>}
            </div>
          </Link>

          <div className="tile-actions">
            <div className="tile-buttons">
              <Button label="Boekingen" size="s" color="green" icon={bookingIcon} link={'/user/stand/' + stand.id + '/manager'}/>
              <Button label="Omhoog" size="s" color="blue" icon={boostIcon} link={'/user/profile-boosts'}/>
            </div>

            <div className="tile-quick-links">
              <Link to={'/user/stand/' + stand.id + '/aanbod'} className="quick-link" title="Aanbod">
                <img src={cartIcon} alt="Aanbod"/>
              </Link>
              <Link to={'/user/stand/' + stand.id + '/locaties'} className="quick-link" title="Waar geweest">
                <img src={mapIcon} alt="Waar geweest"/>
              </Link>
              <Link to={'/user/stand/' + stand.id + '/edit'} className="quick-link" title="Instellingen">
                <img src={cogIcon} alt="Instellingen"/>
              </Link>
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}

export default StandTileList
